<mat-card class="custom-card" appearance="outlined">
  <div class="custom-card-header d-flex align-items-center">
    <mat-card-title>Contrato #{{ contrato.contrato }}</mat-card-title>

    <div class="d-flex align-items-center ms-auto">
      <ng-template #modalContent>
        <app-historico-traslados
          [numeroContrato]="contrato.contrato"
          [estadoContrato]="contrato.EstadoContrato"
        ></app-historico-traslados>
      </ng-template>
      <mat-icon (click)="openModal(modalContent)">article</mat-icon>
      <mat-icon class="mx-2" (click)="onViewClick(contrato)"
        >remove_red_eye</mat-icon
      >
    </div>
  </div>
  <mat-card-content>
    <div class="mt-2">
      <strong>Estado contrato: </strong>
      <span
        class="badge text-white px-2 py-1"
        [ngClass]="getEstadoClass(contrato.EstadoContrato)"
      >
        {{ contrato.EstadoContrato.toUpperCase() }}
      </span>
    </div>
    <div>
      <strong>{{
        isTransitorio(contrato.EstadoContrato)
          ? "Tipo Plan Anterior: "
          : "Tipo Plan: "
      }}</strong>
      <span class="badge bg-primary text-white px-2 py-1">{{
        contrato.TipoPlan
      }}</span>
    </div>
    <div>
      <strong>{{
        isTransitorio(contrato.EstadoContrato)
          ? "Programa Anterior: "
          : "Programa: "
      }}</strong>
      <span
        [ngClass]="{
          'text-danger fw-bold': isTransitorio(contrato.EstadoContrato),
        }"
      >
        {{ contrato.ProgramaNombre }}
      </span>
    </div>
    <div>
      <strong>Cuenta: </strong> {{ contrato.cuenta || contrato.Cuenta }}
    </div>

    <div><strong>Corte: </strong> {{ contrato.DiaCorte }}</div>

    <div><strong>Cód. Tarifa: </strong> {{ contrato.CodigoTarifa }}</div>

    <div>
      <strong>Saldo en mora: </strong>
      <span
        [ngClass]="{
          'text-danger fw-bold': isSaldoEnMora(contrato.SaldoEnMora),
        }"
      >
        {{ UtilFormat.formatMoney(contrato.SaldoEnMora) }}
      </span>
    </div>

    <div>
      <strong>Asesor población: </strong> {{ contrato.AsesorPoblacion }}
    </div>

    <div><strong>Asesor gestión: </strong> {{ contrato.AsesorGestion }}</div>

    <div><strong>Contratante: </strong> {{ contrato.Contratante }}</div>

    <div>
      <strong>Teléfono celular: </strong> {{ contrato.TelefonoCelular }}
    </div>

    <div>
      <strong>Teléfono fijo contratante: </strong> {{ contrato.TelefonoFijo }}
    </div>

    <div>
      <strong>Email contratante: </strong> {{ contrato.EmailContratante }}
    </div>
  </mat-card-content>
</mat-card>
